export default __webpack_public_path__ + "static/media/Limitations.99b8ff52.svg";